/* ws-checkout-reprice.js
 * Sorgt dafuer, dass konfigurierte Produkte (Konfigurator / Veredelung) an der Kasse
 * den korrekten, serverseitig berechneten Preis erhalten.
 * Ablauf: Klick auf "Zur Kasse" -> Warenkorb lesen -> Preis-Backend erstellt eine
 * Bestellung mit gepruefen Preisen -> Weiterleitung zur sicheren Shopify-Zahlungsseite.
 * Warenkoerbe ohne konfigurierte Produkte laufen unveraendert ueber die normale Kasse.
 */
(function () {
  if (window.__wsCheckoutReprice) return;
  window.__wsCheckoutReprice = true;

  var API = 'https://weitsicht-preis.abacusai.app/api/create-draft-order';
  var CFG_KEY = '_ws_cfg';
  var busy = false;

  function hasCfg(item) {
    return item && item.properties && item.properties[CFG_KEY];
  }

  function overlay(show, msg) {
    var el = document.getElementById('ws-reprice-overlay');
    if (!show) { if (el) el.remove(); return; }
    if (!el) {
      el = document.createElement('div');
      el.id = 'ws-reprice-overlay';
      el.style.cssText = 'position:fixed;inset:0;z-index:2147483647;background:rgba(0,0,0,.82);display:flex;align-items:center;justify-content:center;padding:24px;';
      el.innerHTML = '<div style="background:#000;border:1px solid #d4af37;color:#fff;border-radius:12px;padding:24px 28px;max-width:420px;text-align:center;font-family:Montserrat,Arial,sans-serif;font-size:16px;line-height:1.5;"><div id="ws-reprice-msg"></div></div>';
      document.body.appendChild(el);
    }
    document.getElementById('ws-reprice-msg').innerHTML = msg;
  }

  function buildItems(cart) {
    return cart.items.map(function (it) {
      var props = it.properties || {};
      var visible = {};
      Object.keys(props).forEach(function (k) {
        if (k.charAt(0) !== '_' && props[k] !== null && props[k] !== '') visible[k] = String(props[k]);
      });
      if (!hasCfg(it)) {
        return { plain: true, variant_id: it.variant_id, line_quantity: it.quantity, properties: visible };
      }
      var cfg = {};
      try { cfg = JSON.parse(props[CFG_KEY]); } catch (e) { cfg = {}; }
      var item = {
        product_id: it.product_id,
        variant_id: it.variant_id,
        title: it.product_title,
        line_quantity: it.quantity,
        properties: visible
      };
      if (cfg.t === 'textil') {
        item.textil_veredelung = cfg.v || {};
        item.textil_add_digitization = !!cfg.d;
        item.textil_quantity = it.quantity;
      } else {
        item.selected_options = cfg.o || {};
        item.quantity_index = Number(cfg.q || 0);
        if (cfg.w && cfg.h) { item.width_cm = Number(cfg.w); item.height_cm = Number(cfg.h); }
      }
      return item;
    });
  }

  function fail(msg) {
    busy = false;
    overlay(true, msg + '<br><br><button type="button" id="ws-reprice-close" style="background:#d4af37;color:#000;border:0;border-radius:8px;padding:10px 18px;font-weight:700;cursor:pointer;">Schliessen</button>');
    var b = document.getElementById('ws-reprice-close');
    if (b) b.onclick = function () { overlay(false); };
  }

  function run(proceedNormally) {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.some(hasCfg)) { busy = false; proceedNormally(); return; }
        overlay(true, 'Ihre Preise werden geprüft …<br>Sie werden gleich zur sicheren Zahlung weitergeleitet.');
        return fetch(API, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: buildItems(cart) })
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (!res || !res.success || !res.invoice_url) {
              console.error('[ws-checkout] Backend-Fehler', res);
              fail('Die Bestellung konnte leider nicht vorbereitet werden.<br>Bitte versuchen Sie es erneut oder kontaktieren Sie uns.');
              return;
            }
            try { sessionStorage.setItem('ws_last_draft', String(res.draft_order_id)); } catch (e) {}
            return fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' })
              .catch(function () {})
              .then(function () { window.location.href = res.invoice_url; });
          });
      })
      .catch(function (err) {
        console.error('[ws-checkout] Fehler', err);
        fail('Verbindungsfehler. Bitte versuchen Sie es erneut.');
      });
  }

  function isCheckoutTrigger(el) {
    if (!el || !el.closest) return null;
    return el.closest('[name="checkout"], a[href^="/checkout"], a[href*="/checkout?"]');
  }

  document.addEventListener('click', function (e) {
    var t = isCheckoutTrigger(e.target);
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    run(function () {
      window.location.href = '/checkout';
    });
  }, true);

  document.addEventListener('submit', function (e) {
    var sub = e.submitter;
    if (!sub || sub.getAttribute('name') !== 'checkout') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    run(function () { window.location.href = '/checkout'; });
  }, true);

  /* Express-Zahlknoepfe (PayPal/Wallets) wuerden den Basispreis abrechnen:
     bei konfigurierten Produkten im Warenkorb ausblenden. */
  function syncExpress() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var on = !!(cart.items && cart.items.some(hasCfg));
        document.documentElement.classList.toggle('ws-has-config', on);
      })
      .catch(function () {});
  }
  var st = document.createElement('style');
  st.textContent = '.ws-has-config .additional-checkout-buttons,.ws-has-config .cart__dynamic-checkout-buttons,.ws-has-config shopify-accelerated-checkout-cart,.ws-has-config .shopify-payment-button{display:none!important;}';
  document.head.appendChild(st);
  document.addEventListener('DOMContentLoaded', syncExpress);
  document.addEventListener('cart:updated', syncExpress);
  document.addEventListener('cart:refresh', syncExpress);
  var _f = window.fetch;
  window.fetch = function (input) {
    var p = _f.apply(this, arguments);
    try {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update|clear)/.test(u)) p.then(function () { setTimeout(syncExpress, 300); }, function () {});
    } catch (e) {}
    return p;
  };
  syncExpress();
})();
